jQuery(function ($) {
  function initObjectMap() {
    const $mapContainer = $('#objects-map');
    if (!$mapContainer.length) return;

    const coordinatesInput = $('input[name="coordinates"]');
    if (!coordinatesInput.length) return;

    let coordsData;
    try {
      coordsData = JSON.parse(coordinatesInput.val());
    } catch (e) {
      console.error('Invalid coordinates JSON');
      return;
    }

    const filteredCoords = Array.isArray(coordsData.filtered) ? coordsData.filtered : [];

    const markers = [];
    const bounds = new google.maps.LatLngBounds();
    let activeInfoWindow = null;

    const map = new google.maps.Map(document.getElementById('objects-map'), {
      zoom: 8,
      center: { lat: 54.6872, lng: 25.2797 },
      zoomControl: false,
      fullscreenControl: true,
      fullscreenControlOptions: {
        position: google.maps.ControlPosition.BOTTOM_RIGHT
      },
      mapTypeControl: false,
      streetViewControl: false,
    });

    // Get theme directory URL from a data attribute or construct it
    const themeUrl = $mapContainer.data('theme-url') || '/wp-content/themes/office_hunters';

    filteredCoords.forEach((obj, index) => {
      const objectId = parseInt(obj.id, 10);
      if (!obj.coordinates || isNaN(objectId)) return;

      const [lat, lng] = obj.coordinates.split(',').map(parseFloat);
      if (isNaN(lat) || isNaN(lng)) return;

      // Use custom location pin icon
      const iconUrl = `${themeUrl}/images/marker.svg`;

      const marker = new google.maps.Marker({
        position: { lat, lng },
        map,
        icon: {
          url: iconUrl,
          scaledSize: new google.maps.Size(40, 40),
          anchor: new google.maps.Point(20, 40)
        },
        optimized: false
      });

      // Build info window content from object data
      // Get translations from PHP or use defaults
      const translations = typeof mapTranslations !== 'undefined' ? mapTranslations : {
        city: 'City:',
        district: 'District:',
        class: 'Class:',
        built_year: 'Built year:',
        area: 'Area:',
        view: 'View'
      };

      let infoContent = `
        <div class="map-info-window">
          <div class="object-item map-info-window-card mb-0" data-object-id="${objectId}">
            <div class="object-item-thumbnail relative w-full h-[190px] overflow-hidden">
              ${obj.thumbnail ? `<img src="${obj.thumbnail}" alt="${obj.title}" class="w-full h-full object-cover">` : ''}
            </div>
            <div class="object-item-details p-[12px]">
              <h2 class="object-item-title mt-0 mb-[8px] text-[13px] leading-[16px]">${obj.title}</h2>
              <div class="object-item-info mb-[12px] grid grid-cols-2 gap-x-[12px] gap-y-[4px]">
      `;

      if (obj.city) {
        infoContent += `<p class="text-[11px] leading-[14px] m-0">${translations.city} <strong>${obj.city}</strong></p>`;
      }
      if (obj.district) {
        infoContent += `<p class="text-[11px] leading-[14px] m-0">${translations.district} <strong>${obj.district}</strong></p>`;
      }
      if (obj.class) {
        infoContent += `<p class="text-[11px] leading-[14px] m-0">${translations.class} <strong>${obj.class}</strong></p>`;
      }
      if (obj.built_year) {
        infoContent += `<p class="text-[11px] leading-[14px] m-0">${translations.built_year} <strong>${obj.built_year}</strong></p>`;
      }
      if (obj.area) {
        infoContent += `<p class="text-[11px] leading-[14px] m-0">${translations.area} <strong>${obj.area} m²</strong></p>`;
      }

      infoContent += `
              </div>
              <a href="${obj.url}" class="entry-link inline-block text-[12px] py-[6px] pl-0">${translations.view}</a>
            </div>
          </div>
        </div>
      `;

      const infoWindow = new google.maps.InfoWindow({
        content: infoContent,
        maxWidth: 320,
        disableAutoPan: false
      });

      // Track if mouse is over marker or info window
      let mouseOverMarker = false;
      let mouseOverInfoWindow = false;

      // Show info window on hover
      marker.addListener('mouseover', function() {
        mouseOverMarker = true;
        if (activeInfoWindow && activeInfoWindow !== infoWindow) {
          activeInfoWindow.close();
        }
        infoWindow.open(map, marker);
        activeInfoWindow = infoWindow;

        // Add event listeners to info window after it opens
        setTimeout(() => {
          const infoWindowElement = document.querySelector('.gm-style-iw-c');
          if (infoWindowElement) {
            infoWindowElement.addEventListener('mouseenter', function() {
              mouseOverInfoWindow = true;
            });
            infoWindowElement.addEventListener('mouseleave', function() {
              mouseOverInfoWindow = false;
              // Close if mouse is not over marker
              setTimeout(() => {
                if (!mouseOverMarker && !mouseOverInfoWindow) {
                  infoWindow.close();
                  activeInfoWindow = null;
                }
              }, 100);
            });
          }
        }, 100);
      });

      // Close on mouseout after checking both marker and info window
      marker.addListener('mouseout', function() {
        mouseOverMarker = false;
        setTimeout(() => {
          if (!mouseOverMarker && !mouseOverInfoWindow) {
            infoWindow.close();
            activeInfoWindow = null;
          }
        }, 300);
      });

      markers.push(marker);
      bounds.extend(marker.getPosition());

      // Remove visual number marker from .object-item since we're not using numbers anymore
      const $objectEl = $(`#object-${objectId}`);
      const $numEl = $objectEl.find('.object-number');
      if ($numEl.length) {
        $numEl.hide();
      }
    });

    if (markers.length > 0) {
      if (markers.length === 1) {
        // If only 1 object found, center on that location with appropriate zoom
        map.setCenter(markers[0].getPosition());
        map.setZoom(15);
      } else {
        // Multiple objects - fit bounds to show all
        map.fitBounds(bounds);
      }
    }
  }

  window.initObjectMap = initObjectMap;

  if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
    initObjectMap();
  } else {
    const interval = setInterval(() => {
      if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
        clearInterval(interval);
        initObjectMap();
      }
    }, 250);
  }
});
